import React, { useState, useEffect } from "react";
import {
  PASSWORD_MIN_LENGTH,
  PASSWORD_MAX_LENGTH,
  ThemeColor,
  ALERT_TIMEOUT,
  AUTHENTICATION_URL,
} from "../Config";
import { useLocation } from "react-router-dom";

function ChangePasswordContent() {
  //get query parametersƒ
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const id = queryParams.get("id");

  //state
  const [passwordFieldsValues, setPasswordFieldsValues] = useState({
    password_original: "",
    confirm_password: "",
  });

  //submit form button clicked state
  const [submitClicked, setSubmitClicked] = useState(false);

  //alert state
  const [alert, setAlert] = useState({
    type: "success",
    message: "",
    visible: false,
  });

  //use effect handle submit action
  //use effect to handle the submit button click
  useEffect(() => {
    // If the submit button was clicked
    if (submitClicked === true) {
      //call endpoint
      changePasswordFormRequest();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [submitClicked]);

  //chnage password endpoint
  const changePasswordFormRequest = async () => {
    //get the access token from local storage
    var accessToken = localStorage.getItem("access_token");
    accessToken =
      accessToken !== null && accessToken !== "undefined" ? accessToken : "";

    //fetch the status from the API
    await fetch(AUTHENTICATION_URL, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`, // if needed
      },
      body: JSON.stringify({
        request_type: "CHANGE_PASSWORD",
        password_changed: passwordFieldsValues.password_original,
        id: id,
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        //scroll to top
        window.scrollTo(0, 0);
        //check success
        if (data.success === true) {
          //set alert state to show error
          setAlert({
            type: "success",
            message: data.message,
            visible: true,
          });
          //hide alert after 5 seconds
          setTimeout(() => {
            setAlert({ ...alert, visible: false });
          }, ALERT_TIMEOUT);

          //reset output
          setPasswordFieldsValues({
            ...passwordFieldsValues,
            password_original: "",
            confirm_password: "",
          });
        } else {
          //set alert state to show error
          setAlert({
            type: "danger",
            message: data.message,
            visible: true,
          });
          //hide alert after 5 seconds
          setTimeout(() => {
            setAlert({ ...alert, visible: false });
          }, ALERT_TIMEOUT);
        }
        //hide the spinner
        setSubmitClicked(false);

        console.log("Response Data:", data);
      })
      .catch((error) => {
        console.error("Error:", error);
        //set alert state to show error
        setAlert({
          type: "danger",
          message: "Sorry. Something went wrong. Please try again later.",
          visible: true,
        });
        //hide alert after 5 seconds
        setTimeout(() => {
          setAlert({ ...alert, visible: false });
        }, ALERT_TIMEOUT);

        //hide the spinner
        setSubmitClicked(false);
      });
  };

  //submit handler for the form
  const onSubmitConfirmPasswordForm = (event) => {
    // Get the textarea value
    event.preventDefault();

    //check password character count
    if (
      passwordFieldsValues.password_original.length < PASSWORD_MIN_LENGTH ||
      passwordFieldsValues.confirm_password.length > PASSWORD_MAX_LENGTH
    ) {
      //show error
      //set alert state to show error
      setAlert({
        type: "danger",
        message: `Password length must be of ${PASSWORD_MIN_LENGTH}-${PASSWORD_MAX_LENGTH} characters`,
        visible: true,
      });
      //hide alert after 5 seconds
      setTimeout(() => {
        setAlert({ ...alert, visible: false });
      }, ALERT_TIMEOUT);

      //return
      return;
    }

    //check password and confirm password
    if (
      passwordFieldsValues.password_original !==
      passwordFieldsValues.confirm_password
    ) {
      //show error
      //set alert state to show error
      setAlert({
        type: "danger",
        message: `Passwords mismatch`,
        visible: true,
      });
      //hide alert after 5 seconds
      setTimeout(() => {
        setAlert({ ...alert, visible: false });
      }, ALERT_TIMEOUT);

      //return
      return;
    }

    //set the submit clicked state to true
    //can not access the form values directly here
    //as the state is not updated immediately
    //use effect will be called after the state is updated
    setSubmitClicked(true);
  };

  //onvalue change handler for the inputs
  const onChangeConfirmPasswordForm = (event) => {
    // Update the state with the new value
    setPasswordFieldsValues({
      ...passwordFieldsValues,
      [event.target.id]: event.target.value,
    });
  };

  return (
    <div className="p-3">
      <div
        className="container col-md-4 col-md-offset-4"
        style={{ marginTop: "6rem" }}
      >
        {/* Alert for failure */}
        <div
          className={`alert alert-${alert.type} ${
            alert.visible ? "" : "d-none"
          } fade show`}
          role="alert"
          style={{ marginTop: "5rem" }}
        >
          {alert.message}
        </div>

        {/* title */}
        <h1 className="display-6 text-center mt-2">Change Password</h1>

        {/* Change password */}
        <div className="justify-content-center" style={{ width: "100%" }}>
          <form className="mt-5" onSubmit={onSubmitConfirmPasswordForm}>
            <div className="form-group mt-3">
              <label className="text-muted" htmlFor="password_signup">
                Password ({PASSWORD_MIN_LENGTH} - {PASSWORD_MAX_LENGTH}{" "}
                characters)
              </label>
              <div className="mt-1">
                <input
                  type="password"
                  className="form-control"
                  id="password_original"
                  placeholder="Password"
                  style={{ borderColor: ThemeColor, height: "50px" }}
                  onChange={onChangeConfirmPasswordForm}
                  value={passwordFieldsValues.password_original}
                />
              </div>
            </div>
            <div className="form-group mt-3">
              <label className="text-muted" htmlFor="confirm_password_signup">
                Confirm Password
              </label>
              <div className="mt-1">
                <input
                  type="password"
                  className="form-control"
                  id="confirm_password"
                  placeholder="Confirm Password"
                  style={{ borderColor: ThemeColor, height: "50px" }}
                  onChange={onChangeConfirmPasswordForm}
                  value={passwordFieldsValues.confirm_password}
                />
              </div>
            </div>
            {/* Change Password button */}
            <div className="text-center mt-5 justify-content-center d-flex">
              <div
                className={`spinner-border text-dark me-3 align-self-center ${
                  submitClicked ? "" : "d-none"
                }`}
                role="status"
              >
                <span className="sr-only"></span>
              </div>
              <button
                type="submit"
                className="btn btn-secondary fs-3 px-5"
                style={{
                  width: "100%",
                  height: "60px",
                }}
                onClick={(e) => {
                  //blur
                  e.currentTarget.blur();
                }}
              >
                Change Password
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default ChangePasswordContent;
